export default {
  searchStyles: 'Search Styles',
  applyFilters: 'Apply Filters',
  search: 'Search',
  yourSelection: 'Your Selection',
  clearAll: 'Clear All',
  linesheet: 'Linesheet',
}
